import React from "react";
import BackButton from "../../../components/Form/BackButton";
import { imageDefaultPrefixPath } from "../../../config";
import { useProject } from "../../common/ProjectContext";

const ProjectSubHeader = ({ title }) => {
  const { ProjectLogo, ProjectName } = useProject();
  return (
    <h1 className="page-title">
      {" "}
      <BackButton />
      {title}
      <div className="page-title-right">
        {ProjectLogo && (
          <img src={`${imageDefaultPrefixPath}${ProjectLogo}`} alt="" />
        )}{" "}
        {ProjectName}
      </div>
    </h1>
  );
};

export default ProjectSubHeader;
